import { useState } from 'react';
import { faqData } from '../../../mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <h2 className="font-display text-5xl font-bold text-purple-900 mb-4">
          Perguntas Frequentes
        </h2>
        <p className="text-xl text-gray-600 mb-12">
          Tire suas dúvidas sobre o programa
        </p>

        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={item.id}
              className="border-b border-gray-200 hover:bg-purple-50 transition-colors"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-8 flex items-center justify-between text-left cursor-pointer"
              >
                <h4 className="text-xl font-bold text-purple-900 pr-8">
                  {item.question}
                </h4>
                <i
                  className={`ri-add-line text-3xl text-purple-600 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-45' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="pb-8 pt-2">
                  <p className="text-lg text-gray-700 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": faqData.map(item => ({
            "@type": "Question",
            "name": item.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": item.answer
            }
          }))
        })}
      </script>
    </section>
  );
}
